import { format, parse } from "date-fns";

export const generateMonthName = (dateString: string) => {
  // Parse the date string in the format 'yyyy-MM'
  const parsedDate = parse(dateString, "yyyy-MM", new Date());

  // Format the parsed date to display the full month name
  const monthName = format(parsedDate, "MMMM yyyy");

  return monthName;
};
